module.exports = __webpack_public_path__ + "static/MFFL-55468b5128f13ff1355d031914dac719.mp4";